import { FC, useRef } from 'react';
import { Redirect, Route, Switch, useHistory } from 'react-router-dom';
import { observer } from 'mobx-react';
import { useProduct, useTs } from '@/store';
import BackendHeader from '@/components/BackendHeader';
import OT from '@/components/OperateTips';
import './index.less';

/**
 * pages
 */
import Settings from './Settings';
import Phonebook from './Phonebook';
import Callset from './Callset';
import Background from './Background';
import Language from './Language';
import Screensaver from './Screensaver';
import Taskbar from './Taskbar';
import Fitscreen from './Fitscreen';
import Layout from './Layout';

const productList = [
  'gxv3370',
  'gxv3380',
  'gxv3350',
  'gxv3470',
  'gxv3480',
  'gxv3450',
  'gac2570',
];

const Backend: FC = () => {
  const backMainRef = useRef<HTMLDivElement | null>(null);
  const history = useHistory();
  const [product] = useProduct();
  const [ts] = useTs();

  if (!productList.includes(product)) {
    history.push('/');
    return null;
  }

  return (
    <div className='backend-page'>
      <div className='backend-header'>
        <BackendHeader
          onChange={() => {
            backMainRef.current?.scrollTo(0, 0);
          }}
        />
      </div>
      <div className='backend-main' ref={backMainRef}>
        <div className='backend-form' key={ts}>
          <Switch>
            <Route exact path={`/${product}/settings`} component={Settings} />
            <Route exact path={`/${product}/phonebook`} component={Phonebook} />
            <Route exact path={`/${product}/callset`} component={Callset} />
            <Route
              exact
              path={`/${product}/background`}
              component={Background}
            />
            <Route exact path={`/${product}/language`} component={Language} />
            <Route
              exact
              path={`/${product}/screensaver`}
              component={Screensaver}
            />
            <Route exact path={`/${product}/taskbar`} component={Taskbar} />
            <Route exact path={`/${product}/fitscreen`} component={Fitscreen} />
            <Route exact path={`/${product}/layout`} component={Layout} />
            <Redirect to={`/${product}/settings`} />
          </Switch>
        </div>
        <div className='backend-tips'>
          <OT />
        </div>
        <div className='backend-main-copyright'>
          All Rights Reserved Grandstream Networks, Inc.{' '}
          {new Date().getFullYear()}
        </div>
      </div>
    </div>
  );
};

export default observer(Backend);
